/**
 * SourceFlow Enumerable id values object
 *
 * For each of the forms and categories used in the project add a key:id pair to this object to avoid writing id's directly in your codebase.
 *
 * Using enumerable values is much easier to understand than adding id's directly in your code and ensures against typo's
 *
 * @example1: Render contact form
 *
 * <SourceFlowForm formId={sourceflowEnums.forms.contactForm} />
 *
 * @example2: Filter jobs by sector internal
 *
 * jobs.filter(i => JSON.stringify(i.categories).includes(sourceflowEnums.categories.sectors.internal))
 */
export const sourceflowEnums = {

  // Categories
  categories: {
    type: {
      id: "3114446f-24a2-4c58-bf23-282c494788a7",
      contract: "462d3587-d68b-4fc6-b76f-468b6e926a45",
      permanent: "702cbd92-cb40-4c5c-8519-30b1e45d0d95",
      temporary: "95ffe5bf-6dd1-43f4-b7ba-b3e892db06c7",
    },
  },

  seo: {
    site_name: "Lawrence Harvey",
    domain: "www.lawrenceharvey.com",
    logo: "https://media.licdn.com/dms/image/C4E0BAQFPDYp90jxNwQ/company-logo_200_200/0/1671113608801/lawrence_harvey_logo?e=1722470400&v=beta&t=Henf35mLZ5Dx-4XyuwyW5qFR3MEPk0mdcrLw90RTEnE",
  },
};

export default sourceflowEnums;
